import React, { useState } from 'react';
import { Download, X } from 'lucide-react';
import './CVPanel.css';
import { API_URL } from '../config';

const CVPanel = ({ isOpen, onClose, language }) => {
  const [lang, setLang] = useState(language || 'fr');

  if (!isOpen) return null;

  const handleDownloadPDF = () => {
    const url = `${API_URL}/api/generate-latex-pdf/?lang=${lang}`;
    window.open(url, '_blank');
  };

  const toggleLang = () => {
    setLang(prevLang => (prevLang === 'fr' ? 'en' : 'fr'));
  };

  // Fermer le modal si on clique en dehors du conteneur (overlay)
  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('cv-panel-overlay')) {
      onClose();
    }
  };

  return (
    <div className="cv-panel-overlay" onClick={handleOverlayClick}>
      <div className="cv-panel-container">
        {/* PDF Viewer */}
        <div className="cv-pdf-viewer">
          <iframe
            src={`${API_URL}/api/generate-latex-pdf/?lang=${lang}#toolbar=0&navpanes=0&scrollbar=0`}
            title="CV Preview"
            className="pdf-iframe"
            scrolling="no"
            style={{ overflow: 'hidden' }}
          />
        </div>

        {/* Right Controls Panel */}
        <div className="cv-controls">
          <button className="close-btn" onClick={onClose} title="Fermer">
            <X size={24} />
          </button>

          <div className="controls-content">
            <div className="lang-toggle-simple" style={{ display: 'flex', gap: '15px', fontWeight: 'bold' }}>
              <span
                onClick={() => setLang('fr')}
                style={{ cursor: 'pointer', color: lang === 'fr' ? '#22d3ee' : 'rgba(255, 255, 255, 0.4)' }}
              >
                FR
              </span>
              <span style={{ color: 'rgba(255, 255, 255, 0.2)' }}>|</span>
              <span
                onClick={() => setLang('en')}
                style={{ cursor: 'pointer', color: lang === 'en' ? '#22d3ee' : 'rgba(255, 255, 255, 0.4)' }}
              >
                EN
              </span>
            </div>

            <button className="download-btn" onClick={handleDownloadPDF}>
              <Download size={20} />
              <span>{lang === 'fr' ? 'Télécharger' : 'Download'}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CVPanel;
